// Simple ICS generator for a single VEVENT
// Dates are exported in UTC per RFC5545 (Z suffix)

function pad(n) {
  return String(n).padStart(2, '0');
}

function toIcsUtc(dt) {
  const d = new Date(dt);
  return (
    d.getUTCFullYear() +
    pad(d.getUTCMonth() + 1) +
    pad(d.getUTCDate()) +
    'T' +
    pad(d.getUTCHours()) +
    pad(d.getUTCMinutes()) +
    pad(d.getUTCSeconds()) +
    'Z'
  );
}

export function buildIcsEvent({
  title = 'Event',
  start,
  end,
  description = '',
  location = '',
  uid,
  url = '',
}) {
  const dtStart = toIcsUtc(start);
  const dtEnd = toIcsUtc(end || start);
  const dtStamp = toIcsUtc(new Date());
  const safe = (s) => String(s || '').replace(/\n/g, '\\n');
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//PlanOpt//Calendar Export//EN',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `DTSTAMP:${dtStamp}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${safe(title)}`,
    description ? `DESCRIPTION:${safe(description)}` : null,
    location ? `LOCATION:${safe(location)}` : null,
    url ? `URL:${safe(url)}` : null,
    `UID:${safe(uid || `${dtStart}-${Math.random().toString(36).slice(2)}`)}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean);
  // ICS requires CRLF newlines
  return lines.join('\r\n');
}

